import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkantElementsModule } from '@markant/elements-angular';
import { TranslocoModule } from '@jsverse/transloco';
import { SelectableSuborganization } from '@markant-platform/shared/organization/model';
import { Observable } from 'rxjs';
import { SelectableRole } from '@markant-platform/authorizer/model';
import { UiCartridgeRolesAssignmentItemComponent } from '../ui-cartridge-roles-assignment-item/ui-cartridge-roles-assignment-item.component';
import { EditSuborganizationsRoleAssignmentFlow } from '@markant-platform/shared/authorizer/model';

@Component({
  selector: 'markant-platform-ui-cartridge-roles-edit-suborganizations',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, MarkantElementsModule, TranslocoModule, UiCartridgeRolesAssignmentItemComponent],
  templateUrl: './ui-cartridge-roles-edit-suborganizations.component.html',
  styleUrls: ['./ui-cartridge-roles-edit-suborganizations.component.scss'],
})
export class UiCartridgeRolesEditSuborganizationsComponent {
  @Input()
  flow!: EditSuborganizationsRoleAssignmentFlow;

  @Input()
  suborganizations$!: Observable<SelectableSuborganization[]>;

  @Input()
  shouldEnableOverallResponsibility!: boolean;

  @Input()
  variantName!: string;

  @Input()
  role!: SelectableRole;

  @Output()
  suborganizationAdded: EventEmitter<SelectableSuborganization> = new EventEmitter<SelectableSuborganization>();

  @Output()
  suborganizationRemoved: EventEmitter<SelectableSuborganization> = new EventEmitter<SelectableSuborganization>();

  @Output()
  overallResponsibilityAdded: EventEmitter<void> = new EventEmitter<void>();

  protected readonly EditSuborganizationsRoleAssignmentFlow = EditSuborganizationsRoleAssignmentFlow;

  onAddClick(suborganization: SelectableSuborganization): void {
    if (suborganization.selected) {
      return;
    }
    this.suborganizationAdded.next(suborganization);
  }

  onRemoveClick(suborganization: SelectableSuborganization): void {
    this.suborganizationRemoved.next(suborganization);
  }

  onOverallResponsibilityAdded(): void {
    this.overallResponsibilityAdded.next();
  }
}
